import Vue from "vue";
import { Component, Prop, Lifecycle, Data } from "vuety";
import { IProductGroupItem, IProductGroupOptions } from "../../interfaces";
import { TreeItem } from "./treeItem";
import { getRoot } from "../../root";

const templateElement = "v-tmpl-grouptreelist";

@Component({
	template: document.getElementById(templateElement) ? "#" + templateElement : require("./treeList.html"),
	components: { "tree-item": TreeItem },
	name: "tree-list",
})
export class TreeList extends Vue {
	@Prop() public groups: IProductGroupItem[];
	@Prop() public options: IProductGroupOptions;
	@Prop() public parentGroupCode: string;

	@Data() isVisible: boolean;

	@Lifecycle()
	mounted() {
		const setVisible = () => {
			this.isVisible =
				!this.parentGroupCode || ((this.$refs["treeItem"] || []) as TreeItem[]).some(item => item.isVisible);
		};
		getRoot().$watch("currentGroup", setVisible);
		setVisible();
	}
}



// WEBPACK FOOTER //
// ./src/views/tree/treeList.ts